import { createSelector } from 'reselect';
import { isSameDay } from 'date-fns/esm';
import { RootState } from '../state';
import { getSelectedProjectId } from '../bookings/selectors';

export const getBlockedSlots = (state: RootState) => state.blockedSlots.byId;

export const selectBlockedSlotsByProjectId = createSelector([getBlockedSlots, getSelectedProjectId], (slots, projectId) => {
  return Object.values(slots).filter((slot) => slot.projectId === projectId);
});

export const selectBlockedSlotsByDate = createSelector([selectBlockedSlotsByProjectId, (_, date: Date) => date], (slots, date) => {
  return slots.filter((slot) => isSameDay(new Date(slot.blockedDay), date));
});
